<template>
  <a href="javascript:;" class="name-btn" @click="onLoad">{{$t("loadFilter")}}</a>
</template>

<script>
import EventBus from "@/helpers/EventBus";

export default {
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onLoad() {
      EventBus.emit(this.options.emit, this.data.filterJsonData);
    },
  },
};
</script>

<style lang="scss" scoped></style>
